export interface MessageModel {
  user: number
  type: 'in' | 'out'
  text: string
  time: string
  template?: boolean
}

const defaultMessages: Array<MessageModel> = [
  {
    user: 4,
    type: 'in',
    text: 'How likely are you to recommend our company to your friends and family ?',
    time: '2 mins',
  },
  {
    user: 2,
    type: 'out',
    text: 'Hey there, we’re just writing to let you know that you’ve been subscribed to a repository on GitHub.',
    time: '5 mins',
  },
  {
    user: 4,
    type: 'in',
    text: 'Ok, Understood!',
    time: '1 Hour',
  },
  {
    user: 2,
    type: 'out',
    text: 'You’ll receive notifications for all issues, pull requests!',
    time: '2 Hours',
  },
  {
    user: 4,
    type: 'in',
    text: 'You can unwatch this repository immediately by clicking here: <a href="https://keenthemes.com">Keenthemes.com</a>',
    time: '3 Hours',
  },
  {
    user: 2,
    type: 'out',
    text: 'Most purchased Business courses during this sale!',
    time: '4 Hours',
  },
  {
    user: 4,
    type: 'in',
    text: 'Company BBQ to celebrate the last quater achievements and goals. Food and drinks provided',
    time: '5 Hours',
  },
  {
    template: true,
    user: 2,
    type: 'out',
    text: '',
    time: 'Just now',
  },
  {
    template: true,
    user: 4,
    type: 'in',
    text: 'Right before vacation season we have the next Big Deal for you.',
    time: 'Just now',
  },
]

export interface UserInfoModel {
  initials?: {label: string; state: 'warning' | 'danger' | 'primary' | 'success' | 'info'}
  name: string
  avatar?: string
  email: string
  position: string
  online: boolean
}

const defaultUserInfos: Array<UserInfoModel> = [
  {
    name: 'Emma Smith',
    avatar: 'avatars/300-6.jpg',
    email: 'e.smith@kpmg.com.au',
    position: 'Art Director',
    online: false,
  },
  {
    name: 'Melody Macy',
    initials: {label: 'M', state: 'danger'},
    email: 'melody@altbox.com',
    position: 'Marketing Analytic',
    online: true,
  },
  {
    name: 'Max Smith',
    avatar: 'avatars/300-1.jpg',
    email: 'max@kt.com',
    position: 'Software Enginer',
    online: false,
  },
  {
    name: 'Sean Bean',
    avatar: 'avatars/300-5.jpg',
    email: 'sean@dellito.com',
    position: 'Web Developer',
    online: false,
  },
  {
    name: 'Brian Cox',
    avatar: 'avatars/300-25.jpg',
    email: 'brian@exchange.com',
    position: 'UI/UX Designer',
    online: false,
  },
  {
    name: 'Mikaela Collins',
    initials: {label: 'M', state: 'warning'},
    email: 'mikaela@pexcom.com',
    position: 'Head Of Marketing',
    online: true,
  },
  {
    name: 'Francis Mitcham',
    avatar: 'avatars/300-9.jpg',
    email: 'f.mitcham@kpmg.com.au',
    position: 'Software Arcitect',
    online: false,
  },

  {
    name: 'Olivia Wild',
    initials: {label: 'O', state: 'danger'},
    email: 'olivia@corpmail.com',
    position: 'System Admin',
    online: true,
  },
  {
    name: 'Neil Owen',
    initials: {label: 'N', state: 'primary'},
    email: 'owen.neil@gmail.com',
    position: 'Account Manager',
    online: true,
  },
  {
    name: 'Dan Wilson',
    avatar: 'avatars/300-23.jpg',
    email: 'dam@consilting.com',
    position: 'Web Desinger',
    online: false,
  },
  {
    name: 'Emma Bold',
    initials: {label: 'E', state: 'danger'},
    email: 'emma@intenso.com',
    position: 'Corporate Finance',
    online: true,
  },
  {
    name: 'Ana Crown',
    avatar: 'avatars/300-12.jpg',
    email: 'ana.cf@limtel.com',
    position: 'Customer Relationship',
    online: false,
  },
  {
    name: 'Robert Doe',
    initials: {label: 'A', state: 'info'},
    email: 'robert@benko.com',
    position: 'Marketing Executive',
    online: true,
  },
  {
    name: 'John Miller',
    avatar: 'avatars/300-13.jpg',
    email: 'miller@mapple.com',
    position: 'Project Manager',
    online: false,
  },
  {
    name: 'Lucy Kunic',
    initials: {label: 'L', state: 'success'},
    email: 'lucy.m@fentech.com',
    position: 'SEO Master',
    online: true,
  },
  {
    name: 'Ethan Wilder',
    avatar: 'avatars/300-21.jpg',
    email: 'ethan@loop.com.au',
    position: 'Accountant',
    online: true,
  },
]

const messageFromClient: MessageModel = {
  user: 4,
  type: 'in',
  text: 'Thank you for your awesome support!',
  time: 'Just now',
}

export interface AlertModel {
  title: string
  description: string
  time: string
  icon: string
  state: 'primary' | 'danger' | 'warning' | 'success' | 'info'
}

const defaultAlerts: Array<AlertModel> = [
  {
    title: 'Project Alice',
    description: 'Phase 1 development',
    time: '1 hr',
    icon: 'icons/duotune/technology/teh008.svg',
    state: 'primary',
  },
  {
    title: 'HR Confidential',
    description: 'Confidential staff documents',
    time: '2 hrs',
    icon: 'icons/duotune/general/gen044.svg',
    state: 'danger',
  },
  {
    title: 'Company HR',
    description: 'Corporeate staff profiles',
    time: '5 hrs',
    icon: 'icons/duotune/finance/fin006.svg',
    state: 'warning',
  },
  {
    title: 'Project Red',
    description: 'New frontend admin theme',
    time: '2 days',
    icon: 'icons/duotune/files/fil023.svg',
    state: 'success',
  },
  {
    title: 'Project Breafing',
    description: 'Product launch status update',
    time: '21 Jan',
    icon: 'icons/duotune/maps/map001.svg',
    state: 'primary',
  },
  {
    title: 'Banner Assets',
    description: 'Collection of banner images',
    time: '21 Jan',
    icon: 'icons/duotune/general/gen006.svg',
    state: 'info',
  },
  {
    title: 'Icon Assets',
    description: 'Collection of SVG icons',
    time: '20 March',
    icon: 'icons/duotune/art/art002.svg',
    state: 'warning',
  },
]
export interface LogModel {
  code: string
  state: 'success' | 'danger' | 'warning'
  message: string
  time: string
}

const defaultLogs: Array<LogModel> = [
  {code: '200 OK', state: 'success', message: 'New order', time: 'Just now'},
  {code: '500 ERR', state: 'danger', message: 'New customer', time: '2 hrs'},
  {code: '200 OK', state: 'success', message: 'Payment process', time: '5 hrs'},
  {code: '300 WRN', state: 'warning', message: 'Search query', time: '2 days'},
  {code: '200 OK', state: 'success', message: 'API connection', time: '1 week'},
  {code: '200 OK', state: 'success', message: 'Database restore', time: 'Mar 5'},
  {code: '300 WRN', state: 'warning', message: 'System update', time: 'May 15'},
  {code: '300 WRN', state: 'warning', message: 'Server OS update', time: 'Apr 3'},
  {code: '300 WRN', state: 'warning', message: 'API rollback', time: 'Jun 30'},
  {code: '500 ERR', state: 'danger', message: 'Refund process', time: 'Jul 10'},
  {code: '500 ERR', state: 'danger', message: 'Withdrawal process', time: 'Sep 10'},
  {code: '500 ERR', state: 'danger', message: 'Mail tasks', time: 'Dec 10'},
]

const CredithistoryData: Array<any> = [
  {
    date: 'June 26 2022',
    type: 'MMS',
    description: 'Credit use in BMW test',
    credits: '1000',
    balance: 1034,
  },
  {
    date: 'June 27 2022',
    type: 'SMS',
    description: 'Credit use in BMW test',
    credits: '-100',
    balance: 1034,
  },
  {
    date: 'June 28 2022',
    type: 'MMS',
    description: 'Credit use in BMW test',
    credits: '1000',
    balance: 1034,
  },
  {
    date: 'June 29 2022',
    type: 'SMS',
    description: 'Credit use in BMW test',
    credits: '-2000',
    balance: 1034,
  },
]

const BillingPurchaseTableData: Array<any> = [
  {
    date: 'Nov 01,2022',
    invoiceId: 'INV2046',
    type: 'MMS',
    credits: '1000',
    quantity: '5',
    totalGst: '123.22',
    status: 'Paid',
  },
  {
    date: 'Nov 01,2022',
    invoiceId: 'INV2046',
    type: 'SMS',
    credits: '1000',
    quantity: '5',
    totalGst: '123.22',
    status: 'Unpaid',
  },
  {
    date: 'Nov 01,2022',
    invoiceId: 'INV2046',
    type: 'MMS',
    credits: '1000',
    quantity: '5',
    totalGst: '123.22',
    status: 'Paid',
  },
  {
    date: 'Nov 01,2022',
    invoiceId: 'INV2046',
    type: 'SMS',
    credits: '1000',
    quantity: '5',
    totalGst: '123.22',
    status: 'Unpaid',
  },
  {
    date: 'Nov 01,2022',
    invoiceId: 'INV2046',
    type: 'MMS',
    credits: '1000',
    quantity: '5',
    totalGst: '123.22',
    status: 'Paid',
  },
  {
    date: 'Nov 01,2022',
    invoiceId: 'INV2046',
    type: 'SMS',
    credits: '1000',
    quantity: '5',
    totalGst: '123.22',
    status: 'Unpaid',
  },
  {
    date: 'Nov 01,2022',
    invoiceId: 'INV2046',
    type: 'MMS',
    credits: '1000',
    quantity: '5',
    totalGst: '123.22',
    status: 'Paid',
  },
]

const VirtualNumbers: Array<any> = [
  {number: '+98 123456789', status: 'Requested', payment: 'Monthly'},
  {number: '+111 568855545', status: 'Active', payment: 'Yearly'},
  {number: '+5 7842422254', status: 'Inactive', payment: 'Timesrer'},
]

const DraftPageData: Array<any> = [
  {
    type: 'SMS',
    name: 'BMW Test',
    nameSub: 'subtitle',
    createdAt: '24 Jul 22',
    content: 'Hello ,this is your friend....',
  },
  {
    type: 'MMS',
    name: 'BMW Test',
    nameSub: 'subtitle',
    createdAt: '24 Jul 22',
    content: 'Hello ,this is your friend....',
  },
  {
    type: 'SMS',
    name: 'BMW Test',
    nameSub: 'subtitle',
    createdAt: '24 Jul 22',
    content: 'Hello ,this is your friend....',
  },
  {
    type: 'MMS',
    name: 'BMW Test',
    nameSub: 'subtitle',
    createdAt: '24 Jul 22',
    content: 'Hello ,this is your friend....',
  },
]

const CustomOptOutData: Array<any> = [
  {
    name: 'BMW TEST',
    createdAt: '24 Jul 22',
    option1: 'Option Data One 1',
    option2: 'Option Data One 2',
    option3: 'Option Data One 3',
    option4: 'Option Data One 4',
  },
  {
    name: 'BMW TEST',
    createdAt: '24 Jul 22',
    option1: 'Option Data One 1',
    option2: 'Option Data One 2',
    option3: 'Option Data One 3',
    option4: 'Option Data One 4',
  },
  {
    name: 'BMW TEST',
    createdAt: '24 Jul 22',
    option1: 'Option Data One 1',
    option2: 'Option Data One 2',
    option3: 'Option Data One 3',
    option4: 'Option Data One 4',
  },
  {
    name: 'BMW TEST',
    createdAt: '24 Jul 22',
    option1: 'Option Data One 1',
    option2: 'Option Data One 2',
    option3: 'Option Data One 3',
    option4: 'Option Data One 4',
  },
]

const ClientlistData: Array<any> = [
  {name: 'BMW TEST', createdAt: '24 Jul 22', total: 1746, subscribed: 1108, unSubscribed: 193},

  {name: 'BMW TEST', createdAt: '24 Jul 22', total: 1746, subscribed: 1108, unSubscribed: 193},

  {name: 'BMW TEST', createdAt: '24 Jul 22', total: 1746, subscribed: 1108, unSubscribed: 193},

  {name: 'BMW TEST', createdAt: '24 Jul 22', total: 1746, subscribed: 1108, unSubscribed: 193},

  {name: 'BMW TEST', createdAt: '24 Jul 22', total: 1746, subscribed: 1108, unSubscribed: 193},
]

const ClientEditPageData: Array<any> = [
  {
    mobile: '1234567890',
    firstName: 'Jon',
    lastName: 'Doe',
    gender: 'male',
    postCode: '121121',
    custom1: '-',
    custom2: '-',
    custom3: '-',
    custom4: '-',
    status: 'Active',
  },
  {
    mobile: '1234567890',
    firstName: 'Jon',
    lastName: 'Doe',
    gender: 'male',
    postCode: '121121',
    custom1: '-',
    custom2: '-',
    custom3: '-',
    custom4: '-',
    status: 'Unsubscribed',
  },
  {
    mobile: '1234567890',
    firstName: 'Jon',
    lastName: 'Doe',
    gender: 'male',
    postCode: '121121',
    custom1: '-',
    custom2: '-',
    custom3: '-',
    custom4: '-',
    status: 'Active',
  },
  {
    mobile: '1234567890',
    firstName: 'Jon',
    lastName: 'Doe',
    gender: 'male',
    postCode: '121121',
    custom1: '-',
    custom2: '-',
    custom3: '-',
    custom4: '-',
    status: 'Unsubscribed',
  },
  {
    mobile: '1234567890',
    firstName: 'Jon',
    lastName: 'Doe',
    gender: 'male',
    postCode: '121121',
    custom1: '-',
    custom2: '-',
    custom3: '-',
    custom4: '-',
    status: 'Active',
  },
  {
    mobile: '1234567890',
    firstName: 'Jon',
    lastName: 'Doe',
    gender: 'male',
    postCode: '121121',
    custom1: '-',
    custom2: '-',
    custom3: '-',
    custom4: '-',
    status: 'Unsubscribed',
  },
  {
    mobile: '1234567890',
    firstName: 'Jon',
    lastName: 'Doe',
    gender: 'male',
    postCode: '121121',
    custom1: '-',
    custom2: '-',
    custom3: '-',
    custom4: '-',
    status: 'Active',
  },
  {
    mobile: '1234567890',
    firstName: 'Jon',
    lastName: 'Doe',
    gender: 'male',
    postCode: '121121',
    custom1: '-',
    custom2: '-',
    custom3: '-',
    custom4: '-',
    status: 'Unsubscribed',
  },
]

const SubAccountsData: Array<any> = [
  {
    userName: 'Emma Smith',
    email: 'nuttertools@gmail.com',
    role: 'Adminstrator',
    lastLogin: '20 Min Ago',
    twoStep: 'Enabaled',
    joinedDate: 'June 22 2022',
  },
  {
    userName: 'Emma Smith',
    email: 'nuttertools@gmail.com',
    role: 'Adminstrator',
    lastLogin: '20 Min Ago',
    twoStep: '',
    joinedDate: 'June 22 2022',
  },
  {
    userName: 'Emma Smith',
    email: 'nuttertools@gmail.com',
    role: 'Adminstrator',
    lastLogin: '20 Min Ago',
    twoStep: '',
    joinedDate: 'June 22 2022',
  },
  {
    userName: 'Emma Smith',
    email: 'nuttertools@gmail.com',
    role: 'Adminstrator',
    lastLogin: '20 Min Ago',
    twoStep: 'Enabaled',
    joinedDate: 'June 22 2022',
  },
  {
    userName: 'Emma Smith',
    email: 'nuttertools@gmail.com',
    role: 'Adminstrator',
    lastLogin: '20 Min Ago',
    twoStep: '',
    joinedDate: 'June 22 2022',
  },
  {
    userName: 'Emma Smith',
    email: 'nuttertools@gmail.com',
    role: 'Adminstrator',
    lastLogin: '20 Min Ago',
    twoStep: 'Enabaled',
    joinedDate: 'June 22 2022',
  },
  {
    userName: 'Emma Smith',
    email: 'nuttertools@gmail.com',
    role: 'Adminstrator',
    lastLogin: '20 Min Ago',
    twoStep: '',
    joinedDate: 'June 22 2022',
  },
]

const ApiKeyTableData: Array<any> = [
  {
    label: 'none set',
    apiKeys: 'fftt456765gjkkjhi83093985',
    createdAt: 'NOV 1,2021',
    status: 'Active',
  },
  {
    label: 'none set',
    apiKeys: 'fftt456765gjkkjhi83093985',
    createdAt: 'NOV 1,2021',
    status: 'Active',
  },
  {
    label: 'none set',
    apiKeys: 'fftt456765gjkkjhi83093985',
    createdAt: 'NOV 1,2021',
    status: 'Active',
  },
  {
    label: 'none set',
    apiKeys: 'fftt456765gjkkjhi83093985',
    createdAt: 'NOV 1,2021',
    status: 'Active',
  },
  {
    label: 'none set',
    apiKeys: 'fftt456765gjkkjhi83093985',
    createdAt: 'NOV 1,2021',
    status: 'Active',
  },
]

const NewMessageModalMMSData: Array<any> = [
  {smsContent: 'Optout-out surveys'},
  {smsContent: 'Smart links'},
  {smsContent: 'Schedules'},
  {smsContent: 'Custom Landing page'},
  {smsContent: 'RSVP feature for events'},
  {smsContent: 'Catchy image/video/GIF'},
]

const CustomFieldData: Array<any> = [
  {value: 'firstName', label: 'First Name'},
  {value: 'lastName', label: 'Last Name'},
  {value: 'gender', label: 'Gender'},
  {value: 'postCode', label: 'Post Code'},
  {value: 'dateOfBirth', label: 'Date of birth'},
  {value: 'customFiled', label: 'Custom filed'},
]

const OptOutPage: Array<any> = [
  {value: 'button'},
  {value: 'defaultSurvey', label: 'Default survey'},
  {value: 'vipSurvey', label: 'Vip survey'},
  {value: 'eofy', label: 'EOFY'},
  {value: 'discount', lablel: 'Discount'},
]
const WebLinkData: Array<any> = [
  {value: 'button'},
  {value: 'link1', label: 'Link1#'},
  {value: 'link2', label: 'Link2#'},
  {value: 'link3', label: 'Link3#'},
  {value: 'link4', label: 'Link4#'},
]

const NeMessageStep5Data: Array<any> = [
  {title: 'List selected', data: 'VIP List'},
  {title: 'Previously unsub', data: '0'},
  {title: 'Sender ID', data: 'Shared number'},
  {title: 'Staggering', data: '20 message every 10 minutes'},
  {title: 'Landing Page', data: 'landingPage'},
  {title: 'Forward replies', data: 'Email + SMS'},
  {title: 'Email replies', data: 'email@myemail.com.cu'},
  {title: 'SMS replies', data: '0423 456 258'},
  {title: 'Sender ID', data: 'Custom ID - Toyota'},
  {title: 'Active links', data: 'active'},
]

const DashaboardPageData: Array<any> = [
  {
    campaign: 'SMS',
    name: 'BMW Test',
    nameSub: 'Created May 17, 2022 11:22 AM',
    createdAt: '24 Jul 22 - 26 Jul 22',
    recipitance: '2024',
    unSub: '17',
    click: '500',
    resplies: '15',
    status: 'In Progress',
  },
  {
    campaign: 'MMS',
    name: 'BMW Test',
    nameSub: 'Created May 17, 2022 11:22 AM',
    createdAt: '24 Jul 22 - 26 Jul 22',
    recipitance: '2024',
    unSub: '17',
    click: '500',
    resplies: '15',
    status: 'In Progress',
  },
  {
    campaign: 'SMS',
    name: 'BMW Test',
    nameSub: 'Created May 17, 2022 11:22 AM',
    createdAt: '24 Jul 22 - 26 Jul 22',
    recipitance: '2024',
    unSub: '17',
    click: '500',
    resplies: '15',
    status: 'In Progress',
  },
  {
    campaign: 'MMS',
    name: 'BMW Test',
    nameSub: 'Created May 17, 2022 11:22 AM',
    createdAt: '24 Jul 22 - 26 Jul 22',
    recipitance: '2024',
    unSub: '17',
    click: '500',
    resplies: '15',
    status: 'Completed',
  },
]

const configData: Array<any> = [
  {
    title: 'API Keys',
    description:
      'Integrate with our gateway to send messages from within your own application using our API',
    path: '/accounts/api-keys',
  },
  {
    title: 'Email to SMS',
    description: 'Convert and send your email as an SMS and manage replies from your email inbox',
    path: '/email-to-sms',
  },
  {
    title: 'Automations',
    description: 'Set up auto-replies before your next campaign',
    path: '/automation',
  },
]

const customFieldOption: any = [
  {value: 'firstName', label: 'First name'},
  {value: 'gender', label: 'Gender'},
  {value: 'postCode', label: 'Post code'},
  {value: 'dob', label: 'Date of birth'},
  {value: 'customField', label: 'Custom field'},
]

const regions: any = [
  {
    value: 'au',
    label: 'Australia',
  },
  {
    value: 'us',
    label: 'United States',
  },
  {
    value: 'uk',
    label: 'United Kingdom',
  },
  {
    value: 'nz',
    label: 'New Zealand',
  },
  {
    value: 'id',
    label: 'Indonesia',
  }
]

const countries: any = [
  {
    value: 'af',
    label: 'Afghanistan',
  },
  {
    value: 'al',
    label: 'Albania',
  },
  {
    value: 'dz',
    label: 'Algeria',
  },
  {
    value: 'as',
    label: 'American Samoa',
  },
  {
    value: 'ad',
    label: 'Andorra',
  },
  {
    value: 'ao',
    label: 'Angola',
  },
  {
    value: 'ai',
    label: 'Anguilla',
  },
  {
    value: 'aq',
    label: 'Antarctica',
  },
  {
    value: 'ag',
    label: 'Antigua and Barbuda',
  },
  {
    value: 'ar',
    label: 'Argentina',
  },
  {
    value: 'am',
    label: 'Armenia',
  },
  {
    value: 'aw',
    label: 'Aruba',
  },
  {
    value: 'au',
    label: 'Australia',
  },
  {
    value: 'at',
    label: 'Austria',
  },
  {
    value: 'az',
    label: 'Azerbaijan',
  },
  {
    value: 'bs',
    label: 'Bahamas',
  },
  {
    value: 'bh',
    label: 'Bahrain',
  },
  {
    value: 'bd',
    label: 'Bangladesh',
  },
  {
    value: 'bb',
    label: 'Barbados',
  },
  {
    value: 'by',
    label: 'Belarus',
  },
  {
    value: 'be',
    label: 'Belgium',
  },
  {
    value: 'bz',
    label: 'Belize',
  },
  {
    value: 'bj',
    label: 'Benin',
  },
  {
    value: 'bm',
    label: 'Bermuda',
  },
  {
    value: 'bt',
    label: 'Bhutan',
  },
  {
    value: 'bo',
    label: 'Bolivia',
  },
  {
    value: 'ba',
    label: 'Bosnia and Herzegovina',
  },
  {
    value: 'bw',
    label: 'Botswana',
  },
  {
    value: 'bv',
    label: 'Bouvet Island',
  },
  {
    value: 'br',
    label: 'Brazil',
  },
  {
    value: 'io',
    label: 'British Indian Ocean Territory',
  },
  {
    value: 'bn',
    label: 'Brunei Darussalam',
  },
  {
    value: 'bg',
    label: 'Bulgaria',
  },
  {
    value: 'bf',
    label: 'Burkina Faso',
  },
  {
    value: 'bi',
    label: 'Burundi',
  },
  {
    value: 'kh',
    label: 'Cambodia',
  },
  {
    value: 'cm',
    label: 'Cameroon',
  },
  {
    value: 'ca',
    label: 'Canada',
  },
  {
    value: 'cv',
    label: 'Cape Verde',
  },
  {
    value: 'ky',
    label: 'Cayman Islands',
  },
  {
    value: 'cf',
    label: 'Central African Republic',
  },
  {
    value: 'td',
    label: 'Chad',
  },
  {
    value: 'cl',
    label: 'Chile',
  },
  {
    value: 'cn',
    label: 'China',
  },
  {
    value: 'cx',
    label: 'Christmas Island',
  },
  {
    value: 'cc',
    label: 'Cocos (Keeling) Islands',
  },
  {
    value: 'co',
    label: 'Colombia',
  },
  {
    value: 'km',
    label: 'Comoros',
  },
  {
    value: 'cg',
    label: 'Congo',
  },
  {
    value: 'cd',
    label: 'Congo, the Democratic Republic of the',
  },
  {
    value: 'ck',
    label: 'Cook Islands',
  },
  {
    value: 'cr',
    label: 'Costa Rica',
  },
  {
    value: 'ci',
    label: "Cote D'ivoire",
  },
  {
    value: 'hr',
    label: 'Croatia',
  },
  {
    value: 'cu',
    label: 'Cuba',
  },
  {
    value: 'cy',
    label: 'Cyprus',
  },
  {
    value: 'cz',
    label: 'Czech Republic',
  },
  {
    value: 'dk',
    label: 'Denmark',
  },
  {
    value: 'dj',
    label: 'Djibouti',
  },
  {
    value: 'dm',
    label: 'Dominica',
  },
  {
    value: 'do',
    label: 'Dominican Republic',
  },
  {
    value: 'ec',
    label: 'Ecuador',
  },
  {
    value: 'eg',
    label: 'Egypt',
  },
  {
    value: 'sv',
    label: 'El Salvador',
  },
  {
    value: 'gq',
    label: 'Equatorial Guinea',
  },
  {
    value: 'er',
    label: 'Eritrea',
  },
  {
    value: 'ee',
    label: 'Estonia',
  },
  {
    value: 'et',
    label: 'Ethiopia',
  },
  {
    value: 'fk',
    label: 'Falkland Islands (Malvinas)',
  },
  {
    value: 'fo',
    label: 'Faroe Islands',
  },
  {
    value: 'fj',
    label: 'Fiji',
  },
  {
    value: 'fi',
    label: 'Finland',
  },
  {
    value: 'fr',
    label: 'France',
  },
  {
    value: 'gf',
    label: 'French Guiana',
  },
  {
    value: 'pf',
    label: 'French Polynesia',
  },
  {
    value: 'tf',
    label: 'French Southern Territories',
  },
  {
    value: 'ga',
    label: 'Gabon',
  },
  {
    value: 'gm',
    label: 'Gambia',
  },
  {
    value: 'ge',
    label: 'Georgia',
  },
  {
    value: 'de',
    label: 'Germany',
  },
  {
    value: 'gh',
    label: 'Ghana',
  },
  {
    value: 'gi',
    label: 'Gibraltar',
  },
  {
    value: 'gr',
    label: 'Greece',
  },
  {
    value: 'gl',
    label: 'Greenland',
  },
  {
    value: 'gd',
    label: 'Grenada',
  },
  {
    value: 'gp',
    label: 'Guadeloupe',
  },
  {
    value: 'gu',
    label: 'Guam',
  },
  {
    value: 'gt',
    label: 'Guatemala',
  },
  {
    value: 'gn',
    label: 'Guinea',
  },
  {
    value: 'gw',
    label: 'Guinea-Bissau',
  },
  {
    value: 'gy',
    label: 'Guyana',
  },
  {
    value: 'ht',
    label: 'Haiti',
  },
  {
    value: 'hm',
    label: 'Heard Island and Mcdonald Islands',
  },
  {
    value: 'va',
    label: 'Holy See (Vatican City State)',
  },
  {
    value: 'hn',
    label: 'Honduras',
  },
  {
    value: 'hk',
    label: 'Hong Kong',
  },
  {
    value: 'hu',
    label: 'Hungary',
  },
  {
    value: 'is',
    label: 'Iceland',
  },
  {
    value: 'in',
    label: 'India',
  },
  {
    value: 'id',
    label: 'Indonesia',
  },
  {
    value: 'ir',
    label: 'Iran, Islamic Republic of',
  },
  {
    value: 'iq',
    label: 'Iraq',
  },
  {
    value: 'ie',
    label: 'Ireland',
  },
  {
    value: 'il',
    label: 'Israel',
  },
  {
    value: 'it',
    label: 'Italy',
  },
  {
    value: 'jm',
    label: 'Jamaica',
  },
  {
    value: 'jp',
    label: 'Japan',
  },
  {
    value: 'jo',
    label: 'Jordan',
  },
  {
    value: 'kz',
    label: 'Kazakhstan',
  },
  {
    value: 'ke',
    label: 'Kenya',
  },
  {
    value: 'ki',
    label: 'Kiribati',
  },
  {
    value: 'kp',
    label: "Korea, Democratic People's Republic of",
  },
  {
    value: 'kr',
    label: 'Korea, Republic of',
  },
  {
    value: 'kw',
    label: 'Kuwait',
  },
  {
    value: 'kg',
    label: 'Kyrgyzstan',
  },
  {
    value: 'la',
    label: "Lao People's Democratic Republic",
  },
  {
    value: 'lv',
    label: 'Latvia',
  },
  {
    value: 'lb',
    label: 'Lebanon',
  },
  {
    value: 'ls',
    label: 'Lesotho',
  },
  {
    value: 'lr',
    label: 'Liberia',
  },
  {
    value: 'ly',
    label: 'Libyan Arab Jamahiriya',
  },
  {
    value: 'li',
    label: 'Liechtenstein',
  },
  {
    value: 'lt',
    label: 'Lithuania',
  },
  {
    value: 'lu',
    label: 'Luxembourg',
  },
  {
    value: 'mo',
    label: 'Macao',
  },
  {
    value: 'mk',
    label: 'Macedonia, the Former Yugosalv Republic of',
  },
  {
    value: 'mg',
    label: 'Madagascar',
  },
  {
    value: 'mw',
    label: 'Malawi',
  },
  {
    value: 'my',
    label: 'Malaysia',
  },
  {
    value: 'mv',
    label: 'Maldives',
  },
  {
    value: 'ml',
    label: 'Mali',
  },
  {
    value: 'mt',
    label: 'Malta',
  },
  {
    value: 'mh',
    label: 'Marshall Islands',
  },
  {
    value: 'mq',
    label: 'Martinique',
  },
  {
    value: 'mr',
    label: 'Mauritania',
  },
  {
    value: 'mu',
    label: 'Mauritius',
  },
  {
    value: 'yt',
    label: 'Mayotte',
  },
  {
    value: 'mx',
    label: 'Mexico',
  },
  {
    value: 'fm',
    label: 'Micronesia, Federated States of',
  },
  {
    value: 'md',
    label: 'Moldova, Republic of',
  },
  {
    value: 'mc',
    label: 'Monaco',
  },
  {
    value: 'mn',
    label: 'Mongolia',
  },
  {
    value: 'ms',
    label: 'Montserrat',
  },
  {
    value: 'ma',
    label: 'Morocco',
  },
  {
    value: 'mz',
    label: 'Mozambique',
  },
  {
    value: 'mm',
    label: 'Myanmar',
  },
  {
    value: 'na',
    label: 'Namibia',
  },
  {
    value: 'nr',
    label: 'Nauru',
  },
  {
    value: 'np',
    label: 'Nepal',
  },
  {
    value: 'nl',
    label: 'Netherlands',
  },
  {
    value: 'an',
    label: 'Netherlands Antilles',
  },
  {
    value: 'nc',
    label: 'New Caledonia',
  },
  {
    value: 'nz',
    label: 'New Zealand',
  },
  {
    value: 'ni',
    label: 'Nicaragua',
  },
  {
    value: 'ne',
    label: 'Niger',
  },
  {
    value: 'ng',
    label: 'Nigeria',
  },
  {
    value: 'nu',
    label: 'Niue',
  },
  {
    value: 'nf',
    label: 'Norfolk Island',
  },
  {
    value: 'mp',
    label: 'Northern Mariana Islands',
  },
  {
    value: 'no',
    label: 'Norway',
  },
  {
    value: 'om',
    label: 'Oman',
  },
  {
    value: 'pk',
    label: 'Pakistan',
  },
  {
    value: 'pw',
    label: 'Palau',
  },
  {
    value: 'ps',
    label: 'Palestinian Territory, Occupied',
  },
  {
    value: 'pa',
    label: 'Panama',
  },
  {
    value: 'pg',
    label: 'Papua New Guinea',
  },
  {
    value: 'py',
    label: 'Paraguay',
  },
  {
    value: 'pe',
    label: 'Peru',
  },
  {
    value: 'ph',
    label: 'Philippines',
  },
  {
    value: 'pn',
    label: 'Pitcairn',
  },
  {
    value: 'pl',
    label: 'Poland',
  },
  {
    value: 'pt',
    label: 'Portugal',
  },
  {
    value: 'pr',
    label: 'Puerto Rico',
  },
  {
    value: 'qa',
    label: 'Qatar',
  },
  {
    value: 're',
    label: 'Reunion',
  },
  {
    value: 'ro',
    label: 'Romania',
  },
  {
    value: 'ru',
    label: 'Russian Federation',
  },
  {
    value: 'rw',
    label: 'Rwanda',
  },
  {
    value: 'sh',
    label: 'Saint Helena',
  },
  {
    value: 'kn',
    label: 'Saint Kitts and Nevis',
  },
  {
    value: 'lc',
    label: 'Saint Lucia',
  },
  {
    value: 'pm',
    label: 'Saint Pierre and Miquelon',
  },
  {
    value: 'vc',
    label: 'Saint Vincent and the Grenadines',
  },
  {
    value: 'ws',
    label: 'Samoa',
  },
  {
    value: 'sm',
    label: 'San Marino',
  },
  {
    value: 'st',
    label: 'Sao Tome and Principe',
  },
  {
    value: 'sa',
    label: 'Saudi Arabia',
  },
  {
    value: 'sn',
    label: 'Senegal',
  },
  {
    value: 'rs',
    label: 'Serbia and Montenegro',
  },
  {
    value: 'sc',
    label: 'Seychelles',
  },
  {
    value: 'sl',
    label: 'Sierra Leone',
  },
  {
    value: 'sg',
    label: 'Singapore',
  },
  {
    value: 'sk',
    label: 'Slovakia',
  },
  {
    value: 'si',
    label: 'Slovenia',
  },
  {
    value: 'sb',
    label: 'Solomon Islands',
  },
  {
    value: 'so',
    label: 'Somalia',
  },
  {
    value: 'za',
    label: 'South Africa',
  },
  {
    value: 'gs',
    label: 'South Georgia and the South Sandwich Islands',
  },
  {
    value: 'es',
    label: 'Spain',
  },
  {
    value: 'lk',
    label: 'Sri Lanka',
  },
  {
    value: 'sd',
    label: 'Sudan',
  },
  {
    value: 'sr',
    label: 'Suriname',
  },
  {
    value: 'sj',
    label: 'Svalbard and Jan Mayen',
  },
  {
    value: 'sz',
    label: 'Swaziland',
  },
  {
    value: 'se',
    label: 'Sweden',
  },
  {
    value: 'ch',
    label: 'Switzerland',
  },
  {
    value: 'sy',
    label: 'Syrian Arab Republic',
  },
  {
    value: 'tw',
    label: 'Taiwan, Province of China',
  },
  {
    value: 'tj',
    label: 'Tajikistan',
  },
  {
    value: 'tz',
    label: 'Tanzania, United Republic of',
  },
  {
    value: 'th',
    label: 'Thailand',
  },
  {
    value: 'tl',
    label: 'Timor-Leste',
  },
  {
    value: 'tg',
    label: 'Togo',
  },
  {
    value: 'tk',
    label: 'Tokelau',
  },
  {
    value: 'to',
    label: 'Tonga',
  },
  {
    value: 'tt',
    label: 'Trinidad and Tobago',
  },
  {
    value: 'tn',
    label: 'Tunisia',
  },
  {
    value: 'tr',
    label: 'Turkey',
  },
  {
    value: 'tm',
    label: 'Turkmenistan',
  },
  {
    value: 'tc',
    label: 'Turks and Caicos Islands',
  },
  {
    value: 'tv',
    label: 'Tuvalu',
  },
  {
    value: 'ug',
    label: 'Uganda',
  },
  {
    value: 'ua',
    label: 'Ukraine',
  },
  {
    value: 'ae',
    label: 'United Arab Emirates',
  },
  {
    value: 'uk',
    label: 'United Kingdom',
  },
  {
    value: 'gb',
    label: 'United Kingdom',
  },
  {
    value: 'us',
    label: 'United States',
  },
  {
    value: 'um',
    label: 'United States Minor Outlying Islands',
  },
  {
    value: 'uy',
    label: 'Uruguay',
  },
  {
    value: 'uz',
    label: 'Uzbekistan',
  },
  {
    value: 'vu',
    label: 'Vanuatu',
  },
  {
    value: 've',
    label: 'Venezuela',
  },
  {
    value: 'vn',
    label: 'Viet Nam',
  },
  {
    value: 'vg',
    label: 'Virgin Islands, British',
  },
  {
    value: 'vi',
    label: 'Virgin Islands, U.S.',
  },
  {
    value: 'wf',
    label: 'Wallis and Futuna',
  },
  {
    value: 'eh',
    label: 'Western Sahara',
  },
  {
    value: 'ye',
    label: 'Yemen',
  },
  {
    value: 'zm',
    label: 'Zambia',
  },
  {
    value: 'zw',
    label: 'Zimbabwe',
  },
]

const timeZone: any = [
  {
    value: 'Dateline Standard Time',
    label: '(UTC-12:00) International Date Line West',
    utc: ['Etc/GMT+12'],
  },
  {
    value: 'UTC-11',
    label: '(UTC-11:00) Coordinated Universal Time-11',
    utc: ['Etc/GMT+11', 'Pacific/Midway', 'Pacific/Niue', 'Pacific/Pago_Pago'],
  },
  {
    value: 'Hawaiian Standard Time',
    label: '(UTC-10:00) Hawaii',
    utc: [
      'Etc/GMT+10',
      'Pacific/Honolulu',
      'Pacific/Johnston',
      'Pacific/Rarotonga',
      'Pacific/Tahiti',
    ],
  },
  {
    value: 'Alaskan Standard Time',
    label: '(UTC-09:00) Alaska',
    utc: [
      'America/Anchorage',
      'America/Juneau',
      'America/Nome',
      'America/Sitka',
      'America/Yakutat',
    ],
  },
  {
    value: 'Pacific Standard Time (Mexico)',
    label: '(UTC-08:00) Baja California',
    utc: ['America/Santa_Isabel'],
  },
  {
    value: 'Pacific Daylight Time',
    label: '(UTC-07:00) Pacific Daylight Time (US & Canada)',
    utc: ['America/Los_Angeles', 'America/Tijuana', 'America/Vancouver'],
  },
  {
    value: 'Pacific Standard Time',
    label: '(UTC-08:00) Pacific Standard Time (US & Canada)',
    utc: ['America/Los_Angeles', 'America/Tijuana', 'America/Vancouver', 'PST8PDT'],
  },
  {
    value: 'US Mountain Standard Time',
    label: '(UTC-07:00) Arizona',
    utc: [
      'America/Creston',
      'America/Dawson',
      'America/Dawson_Creek',
      'America/Hermosillo',
      'America/Phoenix',
      'America/Whitehorse',
      'Etc/GMT+7',
    ],
  },
  {
    value: 'Mountain Standard Time (Mexico)',
    label: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
    utc: ['America/Chihuahua', 'America/Mazatlan'],
  },
  {
    value: 'Mountain Standard Time',
    label: '(UTC-07:00) Mountain Time (US & Canada)',
    utc: [
      'America/Boise',
      'America/Cambridge_Bay',
      'America/Denver',
      'America/Edmonton',
      'America/Inuvik',
      'America/Ojinaga',
      'America/Yellowknife',
      'MST7MDT',
    ],
  },
  {
    value: 'Central America Standard Time',
    label: '(UTC-06:00) Central America',
    utc: [
      'America/Belize',
      'America/Costa_Rica',
      'America/El_Salvador',
      'America/Guatemala',
      'America/Managua',
      'America/Tegucigalpa',
      'Etc/GMT+6',
      'Pacific/Galapagos',
    ],
  },
  {
    value: 'Central Standard Time',
    label: '(UTC-06:00) Central Time (US & Canada)',
    utc: [
      'America/Chicago',
      'America/Indiana/Knox',
      'America/Indiana/Tell_City',
      'America/Matamoros',
      'America/Menominee',
      'America/North_Dakota/Beulah',
      'America/North_Dakota/Center',
      'America/North_Dakota/New_Salem',
      'America/Rainy_River',
      'America/Rankin_Inlet',
      'America/Resolute',
      'America/Winnipeg',
      'CST6CDT',
    ],
  },
  {
    value: 'Central Standard Time (Mexico)',
    label: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
    utc: [
      'America/Bahia_Banderas',
      'America/Cancun',
      'America/Merida',
      'America/Mexico_City',
      'America/Monterrey',
    ],
  },
  {
    value: 'Canada Central Standard Time',
    label: '(UTC-06:00) Saskatchewan',
    utc: ['America/Regina', 'America/Swift_Current'],
  },
  {
    value: 'SA Pacific Standard Time',
    label: '(UTC-05:00) Bogota, Lima, Quito',
    utc: [
      'America/Bogota',
      'America/Cayman',
      'America/Coral_Harbour',
      'America/Eirunepe',
      'America/Guayaquil',
      'America/Jamaica',
      'America/Lima',
      'America/Panama',
      'America/Rio_Branco',
      'Etc/GMT+5',
    ],
  },
  {
    value: 'Eastern Standard Time',
    label: '(UTC-05:00) Eastern Time (US & Canada)',
    utc: [
      'America/Detroit',
      'America/Havana',
      'America/Indiana/Petersburg',
      'America/Indiana/Vincennes',
      'America/Indiana/Winamac',
      'America/Iqaluit',
      'America/Kentucky/Monticello',
      'America/Louisville',
      'America/Montreal',
      'America/Nassau',
      'America/New_York',
      'America/Nipigon',
      'America/Pangnirtung',
      'America/Port-au-Prince',
      'America/Thunder_Bay',
      'America/Toronto',
    ],
  },
  {
    value: 'Eastern Daylight Time',
    label: '(UTC-04:00) Eastern Daylight Time (US & Canada)',
    utc: [
      'America/Detroit',
      'America/Havana',
      'America/Indiana/Petersburg',
      'America/Indiana/Vincennes',
      'America/Indiana/Winamac',
      'America/Iqaluit',
      'America/Kentucky/Monticello',
      'America/Louisville',
      'America/Montreal',
      'America/Nassau',
      'America/New_York',
      'America/Nipigon',
      'America/Pangnirtung',
      'America/Port-au-Prince',
      'America/Thunder_Bay',
      'America/Toronto',
    ],
  },
  {
    value: 'US Eastern Standard Time',
    label: '(UTC-05:00) Indiana (East)',
    utc: ['America/Indiana/Marengo', 'America/Indiana/Vevay', 'America/Indianapolis'],
  },
  {
    value: 'Venezuela Standard Time',
    label: '(UTC-04:30) Caracas',
    utc: ['America/Caracas'],
  },
  {
    value: 'Paraguay Standard Time',
    label: '(UTC-04:00) Asuncion',
    utc: ['America/Asuncion'],
  },
  {
    value: 'Atlantic Standard Time',
    label: '(UTC-04:00) Atlantic Time (Canada)',
    utc: [
      'America/Glace_Bay',
      'America/Goose_Bay',
      'America/Halifax',
      'America/Moncton',
      'America/Thule',
      'Atlantic/Bermuda',
    ],
  },
  {
    value: 'Central Brazilian Standard Time',
    label: '(UTC-04:00) Cuiaba',
    utc: ['America/Campo_Grande', 'America/Cuiaba'],
  },
  {
    value: 'SA Western Standard Time',
    label: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
    utc: [
      'America/Anguilla',
      'America/Antigua',
      'America/Aruba',
      'America/Barbados',
      'America/Blanc-Sablon',
      'America/Boa_Vista',
      'America/Curacao',
      'America/Dominica',
      'America/Grand_Turk',
      'America/Grenada',
      'America/Guadeloupe',
      'America/Guyana',
      'America/Kralendijk',
      'America/La_Paz',
      'America/Lower_Princes',
      'America/Manaus',
      'America/Marigot',
      'America/Martinique',
      'America/Montserrat',
      'America/Port_of_Spain',
      'America/Porto_Velho',
      'America/Puerto_Rico',
      'America/Santo_Domingo',
      'America/St_Barthelemy',
      'America/St_Kitts',
      'America/St_Lucia',
      'America/St_Thomas',
      'America/St_Vincent',
      'America/Tortola',
      'Etc/GMT+4',
    ],
  },
  {
    value: 'Pacific SA Standard Time',
    label: '(UTC-04:00) Santiago',
    utc: ['America/Santiago', 'Antarctica/Palmer'],
  },
  {
    value: 'Newfoundland Standard Time',
    label: '(UTC-03:30) Newfoundland',
    utc: ['America/St_Johns'],
  },
  {
    value: 'E. South America Standard Time',
    label: '(UTC-03:00) Brasilia',
    utc: ['America/Sao_Paulo'],
  },
  {
    value: 'Argentina Standard Time',
    label: '(UTC-03:00) Buenos Aires',
    utc: [
      'America/Argentina/La_Rioja',
      'America/Argentina/Rio_Gallegos',
      'America/Argentina/Salta',
      'America/Argentina/San_Juan',
      'America/Argentina/San_Luis',
      'America/Argentina/Tucuman',
      'America/Argentina/Ushuaia',
      'America/Buenos_Aires',
      'America/Catamarca',
      'America/Cordoba',
      'America/Jujuy',
      'America/Mendoza',
    ],
  },
  {
    value: 'SA Eastern Standard Time',
    label: '(UTC-03:00) Cayenne, Fortaleza',
    utc: [
      'America/Araguaina',
      'America/Belem',
      'America/Cayenne',
      'America/Fortaleza',
      'America/Maceio',
      'America/Paramaribo',
      'America/Recife',
      'America/Santarem',
      'Antarctica/Rothera',
      'Atlantic/Stanley',
      'Etc/GMT+3',
    ],
  },
  {
    value: 'Greenland Standard Time',
    label: '(UTC-03:00) Greenland',
    utc: ['America/Godthab'],
  },
  {
    value: 'Montevideo Standard Time',
    label: '(UTC-03:00) Montevideo',
    utc: ['America/Montevideo'],
  },
  {
    value: 'Bahia Standard Time',
    label: '(UTC-03:00) Salvador',
    utc: ['America/Bahia'],
  },
  {
    value: 'UTC-02',
    label: '(UTC-02:00) Coordinated Universal Time-02',
    utc: ['America/Noronha', 'Atlantic/South_Georgia', 'Etc/GMT+2'],
  },
  {
    value: 'Mid-Atlantic Standard Time',
    label: '(UTC-02:00) Mid-Atlantic - Old',
    utc: [],
  },
  {
    value: 'Azores Standard Time',
    label: '(UTC-01:00) Azores',
    utc: ['America/Scoresbysund', 'Atlantic/Azores'],
  },
  {
    value: 'Cape Verde Standard Time',
    label: '(UTC-01:00) Cape Verde Is.',
    utc: ['Atlantic/Cape_Verde', 'Etc/GMT+1'],
  },
  {
    value: 'Morocco Standard Time',
    label: '(UTC) Casablanca',
    utc: ['Africa/Casablanca', 'Africa/El_Aaiun'],
  },
  {
    value: 'UTC',
    label: '(UTC) Coordinated Universal Time',
    utc: ['America/Danmarkshavn', 'Etc/GMT'],
  },
  {
    value: 'GMT Standard Time',
    label: '(UTC) Edinburgh, London',
    utc: ['Europe/Isle_of_Man', 'Europe/Guernsey', 'Europe/Jersey', 'Europe/London'],
  },
  {
    value: 'British Summer Time',
    label: '(UTC+01:00) Edinburgh, London',
    utc: ['Europe/Isle_of_Man', 'Europe/Guernsey', 'Europe/Jersey', 'Europe/London'],
  },
  {
    value: 'GMT Standard Time',
    label: '(UTC) Dublin, Lisbon',
    utc: [
      'Atlantic/Canary',
      'Atlantic/Faeroe',
      'Atlantic/Madeira',
      'Europe/Dublin',
      'Europe/Lisbon',
    ],
  },
  {
    value: 'Greenwich Standard Time',
    label: '(UTC) Monrovia, Reykjavik',
    utc: [
      'Africa/Abidjan',
      'Africa/Accra',
      'Africa/Bamako',
      'Africa/Banjul',
      'Africa/Bissau',
      'Africa/Conakry',
      'Africa/Dakar',
      'Africa/Freetown',
      'Africa/Lome',
      'Africa/Monrovia',
      'Africa/Nouakchott',
      'Africa/Ouagadougou',
      'Africa/Sao_Tome',
      'Atlantic/Reykjavik',
      'Atlantic/St_Helena',
    ],
  },
  {
    value: 'W. Europe Standard Time',
    label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    utc: [
      'Arctic/Longyearbyen',
      'Europe/Amsterdam',
      'Europe/Andorra',
      'Europe/Berlin',
      'Europe/Busingen',
      'Europe/Gibraltar',
      'Europe/Luxembourg',
      'Europe/Malta',
      'Europe/Monaco',
      'Europe/Oslo',
      'Europe/Rome',
      'Europe/San_Marino',
      'Europe/Stockholm',
      'Europe/Vaduz',
      'Europe/Vatican',
      'Europe/Vienna',
      'Europe/Zurich',
    ],
  },
  {
    value: 'Central Europe Standard Time',
    label: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    utc: [
      'Europe/Belgrade',
      'Europe/Bratislava',
      'Europe/Budapest',
      'Europe/Ljubljana',
      'Europe/Podgorica',
      'Europe/Prague',
      'Europe/Tirane',
    ],
  },
  {
    value: 'Romance Standard Time',
    label: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
    utc: ['Africa/Ceuta', 'Europe/Brussels', 'Europe/Copenhagen', 'Europe/Madrid', 'Europe/Paris'],
  },
  {
    value: 'Central European Standard Time',
    label: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    utc: ['Europe/Sarajevo', 'Europe/Skopje', 'Europe/Warsaw', 'Europe/Zagreb'],
  },
  {
    value: 'W. Central Africa Standard Time',
    label: '(UTC+01:00) West Central Africa',
    utc: [
      'Africa/Algiers',
      'Africa/Bangui',
      'Africa/Brazzaville',
      'Africa/Douala',
      'Africa/Kinshasa',
      'Africa/Lagos',
      'Africa/Libreville',
      'Africa/Luanda',
      'Africa/Malabo',
      'Africa/Ndjamena',
      'Africa/Niamey',
      'Africa/Porto-Novo',
      'Africa/Tunis',
      'Etc/GMT-1',
    ],
  },
  {
    value: 'Namibia Standard Time',
    label: '(UTC+01:00) Windhoek',
    utc: ['Africa/Windhoek'],
  },
  {
    value: 'GTB Standard Time',
    label: '(UTC+02:00) Athens, Bucharest',
    utc: ['Asia/Nicosia', 'Europe/Athens', 'Europe/Bucharest', 'Europe/Chisinau'],
  },
  {
    value: 'Middle East Standard Time',
    label: '(UTC+02:00) Beirut',
    utc: ['Asia/Beirut'],
  },
  {
    value: 'Egypt Standard Time',
    label: '(UTC+02:00) Cairo',
    utc: ['Africa/Cairo'],
  },
  {
    value: 'Syria Standard Time',
    label: '(UTC+02:00) Damascus',
    utc: ['Asia/Damascus'],
  },
  {
    value: 'E. Europe Standard Time',
    label: '(UTC+02:00) E. Europe',
    utc: [
      'Asia/Nicosia',
      'Europe/Athens',
      'Europe/Bucharest',
      'Europe/Chisinau',
      'Europe/Helsinki',
      'Europe/Kiev',
      'Europe/Mariehamn',
      'Europe/Nicosia',
      'Europe/Riga',
      'Europe/Sofia',
      'Europe/Tallinn',
      'Europe/Uzhgorod',
      'Europe/Vilnius',
      'Europe/Zaporozhye',
    ],
  },
  {
    value: 'South Africa Standard Time',
    label: '(UTC+02:00) Harare, Pretoria',
    utc: [
      'Africa/Blantyre',
      'Africa/Bujumbura',
      'Africa/Gaborone',
      'Africa/Harare',
      'Africa/Johannesburg',
      'Africa/Kigali',
      'Africa/Lubumbashi',
      'Africa/Lusaka',
      'Africa/Maputo',
      'Africa/Maseru',
      'Africa/Mbabane',
      'Etc/GMT-2',
    ],
  },
  {
    value: 'FLE Standard Time',
    label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    utc: [
      'Europe/Helsinki',
      'Europe/Kiev',
      'Europe/Mariehamn',
      'Europe/Riga',
      'Europe/Sofia',
      'Europe/Tallinn',
      'Europe/Uzhgorod',
      'Europe/Vilnius',
      'Europe/Zaporozhye',
    ],
  },
  {
    value: 'Turkey Standard Time',
    label: '(UTC+03:00) Istanbul',
    utc: ['Europe/Istanbul'],
  },
  {
    value: 'Israel Standard Time',
    label: '(UTC+02:00) Jerusalem',
    utc: ['Asia/Jerusalem'],
  },
  {
    value: 'Libya Standard Time',
    label: '(UTC+02:00) Tripoli',
    utc: ['Africa/Tripoli'],
  },
  {
    value: 'Jordan Standard Time',
    label: '(UTC+03:00) Amman',
    utc: ['Asia/Amman'],
  },
  {
    value: 'Arabic Standard Time',
    label: '(UTC+03:00) Baghdad',
    utc: ['Asia/Baghdad'],
  },
  {
    value: 'Kaliningrad Standard Time',
    label: '(UTC+02:00) Kaliningrad',
    utc: ['Europe/Kaliningrad'],
  },
  {
    value: 'Arab Standard Time',
    label: '(UTC+03:00) Kuwait, Riyadh',
    utc: ['Asia/Aden', 'Asia/Bahrain', 'Asia/Kuwait', 'Asia/Qatar', 'Asia/Riyadh'],
  },
  {
    value: 'E. Africa Standard Time',
    label: '(UTC+03:00) Nairobi',
    utc: [
      'Africa/Addis_Ababa',
      'Africa/Asmera',
      'Africa/Dar_es_Salaam',
      'Africa/Djibouti',
      'Africa/Juba',
      'Africa/Kampala',
      'Africa/Khartoum',
      'Africa/Mogadishu',
      'Africa/Nairobi',
      'Antarctica/Syowa',
      'Etc/GMT-3',
      'Indian/Antananarivo',
      'Indian/Comoro',
      'Indian/Mayotte',
    ],
  },
  {
    value: 'Moscow Standard Time',
    label: '(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk',
    utc: ['Europe/Kirov', 'Europe/Moscow', 'Europe/Simferopol', 'Europe/Volgograd', 'Europe/Minsk'],
  },
  {
    value: 'Samara Time',
    label: '(UTC+04:00) Samara, Ulyanovsk, Saratov',
    utc: ['Europe/Astrakhan', 'Europe/Samara', 'Europe/Ulyanovsk'],
  },
  {
    value: 'Iran Standard Time',
    label: '(UTC+03:30) Tehran',
    utc: ['Asia/Tehran'],
  },
  {
    value: 'Arabian Standard Time',
    label: '(UTC+04:00) Abu Dhabi, Muscat',
    utc: ['Asia/Dubai', 'Asia/Muscat', 'Etc/GMT-4'],
  },
  {
    value: 'Azerbaijan Standard Time',
    label: '(UTC+04:00) Baku',
    utc: ['Asia/Baku'],
  },
  {
    value: 'Mauritius Standard Time',
    label: '(UTC+04:00) Port Louis',
    utc: ['Indian/Mahe', 'Indian/Mauritius', 'Indian/Reunion'],
  },
  {
    value: 'Georgian Standard Time',
    label: '(UTC+04:00) Tbilisi',
    utc: ['Asia/Tbilisi'],
  },
  {
    value: 'Caucasus Standard Time',
    label: '(UTC+04:00) Yerevan',
    utc: ['Asia/Yerevan'],
  },
  {
    value: 'Afghanistan Standard Time',
    label: '(UTC+04:30) Kabul',
    utc: ['Asia/Kabul'],
  },
  {
    value: 'West Asia Standard Time',
    label: '(UTC+05:00) Ashgabat, Tashkent',
    utc: [
      'Antarctica/Mawson',
      'Asia/Aqtau',
      'Asia/Aqtobe',
      'Asia/Ashgabat',
      'Asia/Dushanbe',
      'Asia/Oral',
      'Asia/Samarkand',
      'Asia/Tashkent',
      'Etc/GMT-5',
      'Indian/Kerguelen',
      'Indian/Maldives',
    ],
  },
  {
    value: 'Yekaterinburg Time',
    label: '(UTC+05:00) Yekaterinburg',
    utc: ['Asia/Yekaterinburg'],
  },
  {
    value: 'Pakistan Standard Time',
    label: '(UTC+05:00) Islamabad, Karachi',
    utc: ['Asia/Karachi'],
  },
  {
    value: 'India Standard Time',
    label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    utc: ['Asia/Kolkata', 'Asia/Calcutta'],
  },
  {
    value: 'Sri Lanka Standard Time',
    label: '(UTC+05:30) Sri Jayawardenepura',
    utc: ['Asia/Colombo'],
  },
  {
    value: 'Nepal Standard Time',
    label: '(UTC+05:45) Kathmandu',
    utc: ['Asia/Kathmandu'],
  },
  {
    value: 'Central Asia Standard Time',
    label: '(UTC+06:00) Nur-Sultan (Astana)',
    utc: [
      'Antarctica/Vostok',
      'Asia/Almaty',
      'Asia/Bishkek',
      'Asia/Qyzylorda',
      'Asia/Urumqi',
      'Etc/GMT-6',
      'Indian/Chagos',
    ],
  },
  {
    value: 'Bangladesh Standard Time',
    label: '(UTC+06:00) Dhaka',
    utc: ['Asia/Dhaka', 'Asia/Thimphu'],
  },
  {
    value: 'Myanmar Standard Time',
    label: '(UTC+06:30) Yangon (Rangoon)',
    utc: ['Asia/Rangoon', 'Indian/Cocos'],
  },
  {
    value: 'SE Asia Standard Time',
    label: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
    utc: [
      'Antarctica/Davis',
      'Asia/Bangkok',
      'Asia/Hovd',
      'Asia/Jakarta',
      'Asia/Phnom_Penh',
      'Asia/Pontianak',
      'Asia/Saigon',
      'Asia/Vientiane',
      'Etc/GMT-7',
      'Indian/Christmas',
    ],
  },
  {
    value: 'N. Central Asia Standard Time',
    label: '(UTC+07:00) Novosibirsk',
    utc: ['Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk'],
  },
  {
    value: 'China Standard Time',
    label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    utc: ['Asia/Hong_Kong', 'Asia/Macau', 'Asia/Shanghai'],
  },
  {
    value: 'North Asia Standard Time',
    label: '(UTC+08:00) Krasnoyarsk',
    utc: ['Asia/Krasnoyarsk'],
  },
  {
    value: 'Singapore Standard Time',
    label: '(UTC+08:00) Kuala Lumpur, Singapore',
    utc: [
      'Asia/Brunei',
      'Asia/Kuala_Lumpur',
      'Asia/Kuching',
      'Asia/Makassar',
      'Asia/Manila',
      'Asia/Singapore',
      'Etc/GMT-8',
    ],
  },
  {
    value: 'W. Australia Standard Time',
    label: '(UTC+08:00) Perth',
    utc: ['Australia/Perth', 'Antarctica/Casey'],
  },
  {
    value: 'Taipei Standard Time',
    label: '(UTC+08:00) Taipei',
    utc: ['Asia/Taipei'],
  },
  {
    value: 'Ulaanbaatar Standard Time',
    label: '(UTC+08:00) Ulaanbaatar',
    utc: ['Asia/Choibalsan', 'Asia/Ulaanbaatar'],
  },
  {
    value: 'North Asia East Standard Time',
    label: '(UTC+08:00) Irkutsk',
    utc: ['Asia/Irkutsk'],
  },
  {
    value: 'Japan Standard Time',
    label: '(UTC+09:00) Osaka, Sapporo, Tokyo',
    utc: ['Asia/Dili', 'Asia/Jayapura', 'Asia/Tokyo', 'Etc/GMT-9', 'Pacific/Palau'],
  },
  {
    value: 'Korea Standard Time',
    label: '(UTC+09:00) Seoul',
    utc: ['Asia/Pyongyang', 'Asia/Seoul'],
  },
  {
    value: 'Cen. Australia Standard Time',
    label: '(UTC+09:30) Adelaide',
    utc: ['Australia/Adelaide', 'Australia/Broken_Hill'],
  },
  {
    value: 'AUS Central Standard Time',
    label: '(UTC+09:30) Darwin',
    utc: ['Australia/Darwin'],
  },
  {
    value: 'E. Australia Standard Time',
    label: '(UTC+10:00) Brisbane',
    utc: ['Australia/Brisbane', 'Australia/Lindeman'],
  },
  {
    value: 'AUS Eastern Standard Time',
    label: '(UTC+10:00) Canberra, Melbourne, Sydney',
    utc: ['Australia/Melbourne', 'Australia/Sydney'],
  },
  {
    value: 'West Pacific Standard Time',
    label: '(UTC+10:00) Guam, Port Moresby',
    utc: [
      'Antarctica/DumontDUrville',
      'Etc/GMT-10',
      'Pacific/Guam',
      'Pacific/Port_Moresby',
      'Pacific/Saipan',
      'Pacific/Truk',
    ],
  },
  {
    value: 'Tasmania Standard Time',
    label: '(UTC+10:00) Hobart',
    utc: ['Australia/Currie', 'Australia/Hobart'],
  },
  {
    value: 'Yakutsk Standard Time',
    label: '(UTC+09:00) Yakutsk',
    utc: ['Asia/Chita', 'Asia/Khandyga', 'Asia/Yakutsk'],
  },
  {
    value: 'Central Pacific Standard Time',
    label: '(UTC+11:00) Solomon Is., New Caledonia',
    utc: [
      'Antarctica/Macquarie',
      'Etc/GMT-11',
      'Pacific/Efate',
      'Pacific/Guadalcanal',
      'Pacific/Kosrae',
      'Pacific/Noumea',
      'Pacific/Ponape',
    ],
  },
  {
    value: 'Vladivostok Standard Time',
    label: '(UTC+11:00) Vladivostok',
    utc: ['Asia/Sakhalin', 'Asia/Ust-Nera', 'Asia/Vladivostok'],
  },
  {
    value: 'New Zealand Standard Time',
    label: '(UTC+12:00) Auckland, Wellington',
    utc: ['Antarctica/McMurdo', 'Pacific/Auckland'],
  },
  {
    value: 'UTC+12',
    label: '(UTC+12:00) Coordinated Universal Time+12',
    utc: [
      'Etc/GMT-12',
      'Pacific/Funafuti',
      'Pacific/Kwajalein',
      'Pacific/Majuro',
      'Pacific/Nauru',
      'Pacific/Tarawa',
      'Pacific/Wake',
      'Pacific/Wallis',
    ],
  },
  {
    value: 'Fiji Standard Time',
    label: '(UTC+12:00) Fiji',
    utc: ['Pacific/Fiji'],
  },
  {
    value: 'Magadan Standard Time',
    label: '(UTC+12:00) Magadan',
    utc: ['Asia/Anadyr', 'Asia/Kamchatka', 'Asia/Magadan', 'Asia/Srednekolymsk'],
  },
  {
    value: 'Kamchatka Standard Time',
    label: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
    utc: ['Asia/Kamchatka'],
  },
  {
    value: 'Tonga Standard Time',
    label: "(UTC+13:00) Nuku'alofa",
    utc: ['Etc/GMT-13', 'Pacific/Enderbury', 'Pacific/Fakaofo', 'Pacific/Tongatapu'],
  },
  {
    value: 'Samoa Standard Time',
    label: '(UTC+13:00) Samoa',
    utc: ['Pacific/Apia'],
  },
]

const defaultRegion: string = 'au'

export {
  defaultMessages,
  defaultUserInfos,
  defaultAlerts,
  defaultLogs,
  messageFromClient,
  CredithistoryData,
  BillingPurchaseTableData,
  VirtualNumbers,
  DraftPageData,
  CustomOptOutData,
  ClientlistData,
  ClientEditPageData,
  SubAccountsData,
  ApiKeyTableData,
  NewMessageModalMMSData,
  CustomFieldData,
  OptOutPage,
  WebLinkData,
  NeMessageStep5Data,
  DashaboardPageData,
  configData,
  customFieldOption,
  countries,
  timeZone,
  regions,
  defaultRegion,
}
